/*
 * File: PageSubHeader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:38:40 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Col, Menu, Row } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGetApplicationQuery } from 'redux/services/freddyCadabby/freddyCadabbyApi';
import { useAppSelector } from 'redux/store';
import { InlineStylesModel } from '../../models/InlineStylesModel';

const styles: InlineStylesModel = {
  row: {
    backgroundColor: '#181823',
    padding: '0 50px',
    color: '#84859a',
    fontSize: '1rem',
    maxWidth: 1920,
    margin: '0 auto'
  },
  smallContainer: {
    width: 298
  },
  largeContainer: {
    width: 365
  },
  row2: {
    width: '100%',
    maxWidth: 1920
  }
};

export const PageSubHeader = (): JSX.Element => {
  const [selectedMenu, _setSelectedMenu] = useState<string>('search');
  const { pathname } = useLocation();
  const applicationId = pathname.includes('/applications/') && pathname.split('/')[2];
  const isRecyclingBinPage = pathname.includes('/recycle-bin');
  const isCreatePage = pathname.includes('create');
  const isEdit = pathname.includes('/edit');
  const { company, companyName } = useAppSelector((state) => state.app);

  let customerName = '';

  /* ******************** API Hooks ******************** */
  const { data: applicationData, isFetching: isApplicationDataFetching } = useGetApplicationQuery(applicationId || skipToken);

  if (applicationData && !isApplicationDataFetching && applicationId && !isRecyclingBinPage && !isCreatePage) {
    customerName = `Application - ${applicationData?.name}`;
  } else {
    customerName = '';
  }

  useEffect(() => {
    if (pathname.includes('/create')) _setSelectedMenu('create');
    if (pathname.includes('/edit')) _setSelectedMenu('edit');
    if (pathname.includes('/search')) _setSelectedMenu('search');
    if (pathname.includes('/recycle-bin')) _setSelectedMenu('');
    if (!pathname.includes('/create') && !pathname.includes('/recycle-bin') && !pathname.includes('/edit') && !pathname.includes('/search')) _setSelectedMenu('dashboard');
  }, [pathname]);

  // JSX
  const featureMenuJSX = (
    <Menu disabledOverflow={true} mode="horizontal" theme="dark" activeKey={selectedMenu} defaultSelectedKeys={[selectedMenu]} selectedKeys={[selectedMenu]}>
      <Menu.Item key="dashboard">
        <Link to={`/business/${company}`}>Dashboard</Link>
      </Menu.Item>
      <Menu.Item key="search">
        <Link to={`/business/${company}/search`}>Search</Link>
      </Menu.Item>
      <Menu.Item key="create">
        <Link to={`/business/${company}/create`}>Create</Link>
      </Menu.Item>
      {isEdit && (
        <Menu.Item key="edit" disabled={false}>
          Edit
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div style={{ width: '100%', backgroundColor: 'rgb(24, 24, 35)' }}>
      <Row style={styles.row} justify="space-between" align="middle">
        <Col>{companyName ? companyName : null}</Col>
        <Col>{featureMenuJSX}</Col>
      </Row>
    </div>
  );
};
